import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomInput } from '../../styledComponents';
import './select-input.scss';
import { useState } from 'react';

export default function SelectInput({
  value,
  options,
  onSelect,
  className,
  placeholder,
  placeholderValue = '',
  customValue,
  customValuePlaceholder,
  customValueInputStyle,
  customValuePrefix,
  customValuePostfix,
  customInputType,
  footer,
}) {
  const [customValueText, setCustomValueText] = useState('');
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Select
      onClick={(e) => e.stopPropagation()}
      size="small"
      value={value}
      className={`${className} custom-select-input`}
      IconComponent={KeyboardArrowDownIcon}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      sx={{
        color: value === placeholderValue ? 'var(--text-disabled)' : '',
        paddingLeft: '2px !important',
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            padding: '8px',
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem
          sx={{
            padding: '4px 10px',
            borderRadius: '5px',
            background:
              option.value === value ? 'var(--purple-p-50) !important' : '',
            marginBottom: '8px',
            display: option?.ignoreRender ? 'none' : undefined,
          }}
          value={option.value}
          onClick={() => {
            onSelect(option.value);
            setCustomValueText('');
          }}
        >
          <div
            style={{
              fontSize: '14px',
              fontWeight: '400',
            }}
          >
            {option.text}
          </div>
        </MenuItem>
      ))}
      {!!placeholder && (
        <MenuItem disabled value={placeholderValue} style={{ display: 'none' }}>
          {placeholder}
        </MenuItem>
      )}
      {customValueText?.length > 0 && (
        <MenuItem value={customValueText} style={{ display: 'none' }}>
          {customValuePrefix}
          {customValueText}
          {customValuePostfix}
        </MenuItem>
      )}
      {!!customValue && (
        <div className="custom-select-input__custom-input">
          {!!customValueText && customValuePrefix && (
            <div className="custom-select-input__custom-input-prefix">
              {customValuePrefix}
            </div>
          )}

          <CustomInput
            type={customInputType}
            placeholder={customValuePlaceholder}
            style={{
              padding: `7.5px ${customValuePrefix ? '18px' : '7.5px'}`,
              ...customValueInputStyle,
            }}
            value={customValueText}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => {
              setCustomValueText(e.target.value);
              onSelect(e.target.value);
              e.stopPropagation();
            }}
          />
        </div>
      )}
      {footer && (
        <div>
          <div className="footer-divider" />
          {footer({ handleClose })}
        </div>
      )}
    </Select>
  );
}
